import styled from "styled-components";
import {useGetNewsRoomQuery} from "@/api/newsRoomApi";
import Pagination from "@/components/common/Pagination";
import {useState} from "react";
import {SIZES} from "@/components/constants";
import NewsBg from "@public/assets/main/newsroom-bg.png"
import {useLocale} from "next-intl";

const NewsRoomSection = ({data}) => {
    const [offset, setOffset] = useState(1);
    const locale = useLocale();
    const { data: newsData, isLoading } = useGetNewsRoomQuery({ page: offset, locale });
    return(
        <>
            {
                !isLoading && newsData &&
                <SectionWrap>
                    <div className={"container"}>
                        <h2 className={"section-title"} dangerouslySetInnerHTML={{__html: data["newsroom-text"]}}/>
                        <div className={"news-list"}>
                            {
                                newsData.return && newsData.data && newsData.data.length > 0 &&
                                newsData.data.map((item, idx) =>
                                        <div
                                            className={"item"}
                                            key={idx}
                                            onClick={() => {
                                                window.open(item.url, "_blank", "noopener,noreferrer");
                                            }}
                                        >
                                            <img src={item?.image_url} alt={item?.image_name}/>
                                            <div className={"info"}>
                                                <p>{item.title}</p>
                                            </div>
                                        </div>
                                    )
                            }
                        </div>
                        {newsData?.totalPages ? (
                            <div className={"page-wrap"}>
                                <Pagination
                                    page={newsData?.page || offset}
                                    totalPages={newsData.totalPages}
                                    onChange={setOffset}
                                    visibleCount={5}
                                />
                            </div>
                        ) : null}
                    </div>
                    <div className={"section-bg-cover"}></div>
                </SectionWrap>
            }
        </>
    )
}
const SectionWrap = styled.section`
    background-size: 100% 100%;
    padding: 96px 0;
    background-repeat: no-repeat;
    background-position: center;
    background-image:  url(${NewsBg?.src});
    position: relative;
    overflow: hidden;
    .container{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 48px;
        width: 100%;
        margin: 0 auto;
        position: relative;
        z-index: 2;
        padding: 0 20px;
        .section-title{
            font-size: 18px;
            line-height: 64px;
            font-weight: 700;
        }
        .news-list{
            min-height: 306px;
            display: grid;
            grid-template-columns: 1fr 1fr;
            column-gap: 1.5rem;
            row-gap: 2.5rem;
            .item{
                background-color: #fff;
                border-radius: 24px;
                overflow: hidden;
                flex-direction: column;
                display: flex;
                cursor: pointer;
                img{
                    height: 202px;
                    object-fit: cover;
                }
                .info{
                    padding: 24px;
                    p{
                        font-size: 14px;
                        line-height: 20px;
                    }
                }
            }
        }
        .page-wrap{
            margin-top: 40px;
        }
    }
    .section-bg-cover{
        opacity: 0.75;
        background-color: #72b1b9;
        width: 100%;
        height: 100%;
        z-index: 1;
        position: absolute;
        top: 0;
        left: 0;
    }
    @media (max-width: ${SIZES.TABLET}) {
        .container{
            .news-list{
                grid-template-columns: 1fr;
            }
        }
    }
    @media (min-width: ${SIZES.MOBILE}) {
        .container{
            max-width: 640px;
            .news-list{
                grid-template-columns: repeat(2, minmax(0, 1fr));
            }
        }
    }
    @media (min-width: ${SIZES.MOBILE_L}) {
        .container{
            max-width: 768px;
            .news-list{
                grid-template-columns: repeat(3, minmax(0, 1fr));    
                .item{
                    .info{
                        p{
                            font-size: 16px;
                            line-height: 24px;
                        }
                    }
                }
            }
        }
    }
    @media (min-width: ${SIZES.TABLET}) {
        padding: 120px 0;
        .container{
            max-width: 1024px;
            .section-title{
                font-size: 40px;
            }
            .news-list{
                grid-template-columns: repeat(4, minmax(0, 1fr));
                .item{
                    .info{
                        p{
                            font-size: 18px;
                            line-height: 28px;
                        }
                    }
                }
            }
        }
    }

    @media (min-width: ${SIZES.TABLET_L}) {
        .container{
            max-width: 1280px;
        }
    }
    @media (min-width: ${SIZES.PC}) {
        .container{
            max-width: 1536px;
        }
    }
`
export default NewsRoomSection;